import React, { useEffect } from 'react'
import JobItem from '../components/JobItem'
import Header from '../components/Header'
import Layout from '../components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { fetchJobs } from '../features/jobs/jobsSlice'

export default function Home() {
    const dispatch = useDispatch()
    const { jobs, isDelete, isLoading } = useSelector(state => state.jobs);
    const { searchKeyword, jobType, salaryType } = useSelector(state => state.filter)

    useEffect(() => {
        dispatch(fetchJobs())
    }, [dispatch, isDelete])

    let content = ""
    if (jobs?.length > 0 && !isLoading) {
        content = jobs
            ?.filter(job => job.type?.toLowerCase()?.includes(jobType))
            ?.filter(job => job.title?.toLowerCase()?.includes(searchKeyword?.toLowerCase()))
            ?.sort((a, b) => {
                if (salaryType === "lowTohigh") {
                    return a.salary - b.salary;
                }
                if (salaryType === "highTolow") {
                    return b.salary - a.salary;
                }
                return 0;
            })
            ?.map(job => <JobItem key={job.id} job={job} />)
    } else if (jobs?.length === 0 && !isLoading) {
        content = <h2 style={{ color: "#fff" }}>No jobs found.</h2>
    } else {
        content = <h2 style={{ color: "#fff" }}>Something is wrong.</h2>
    }


    return (
        <Layout>
            <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
                <Header />
                <div className="jobs-list">
                    {
                        content
                    }
                </div>
            </main>
        </Layout>
    )
}
